<template>
  <div>
    <div class="public-table-but__left">
      <div class="item">
        <div class="item-wp" v-if="searchShow">
          <div class="item-son">
            <el-input
                v-model="listParams.searchKey"
                placeholder="搜索关键词"
                @keyup.enter.native="queryTableData"
            ></el-input>
          </div>
          <div class="item-son">
            <el-select
                v-model="listParams.paymentMchId"
                clearable
                filterable
                placeholder="请选择商户"
                style="width: 100%"
            >
              <el-option
                  v-for="(item, index) in BusinessListings"
                  :key="index"
                  :label="item.mchName+'('+item.mchId+')'"
                  :value="item.paymentMchId"
              ></el-option>
            </el-select>
          </div>
          <div class="item-son">
            <el-button type="primary" @click="queryTableData"
            >查询 <i class="el-icon-search"></i>
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="public-table-data">
      <el-table
          ref="multipleTable"
          size="medium"
          :data="tableData"
          border
          style="width: 100%;"
          row-key="menuId"
          v-loading="loading"
      >
        <el-table-column fixed label="序号" type="index" width="50" align="center">
          <template slot-scope="scope">
            <span>{{scope.$index+1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="mchId" label="商户ID" width="200" align="center">
        </el-table-column>
        <el-table-column prop="mchName" label="商户名称" width="200" align="center">
        </el-table-column>
        <el-table-column prop="complaintId" label="投诉单号" width="200" align="center">
        </el-table-column>
        <el-table-column prop="complaintDetail" label="投诉内容" width="200" align="center">
        </el-table-column>
        <el-table-column prop="amount" label="订单金额" width="100" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.amount / 100}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="payCode" label="支付单号" width="200" align="center">
        </el-table-column>
        <el-table-column prop="transactionId" label="交易单号" width="200" align="center">
        </el-table-column>
        <el-table-column prop="complaintTime" label="投诉时间" width="200" align="center">
        </el-table-column>
        <el-table-column prop="complaintHandleState" label="状态" width="200" align="center">
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="public-pagination">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pages.pageNo"
            :page-sizes="[PAGE_SIZE, 50, 100, 200, 400]"
            :page-size="pages.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import {PAGE_SIZE} from "@config";
export default {
  data() {
    return {
      listParams: {
        searchKey:'',
        paymentMchId:''
      },
      tableData: [],
      total: 0,
      BusinessListings:[],
      PAGE_SIZE,
      loading:false,
      pages: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      searchShow: false,
    };
  },
  created() {
    this.queryTableData();
    this.getBusinessListings()
    this.getPermissionButtonList()
  },
  computed: {

  },
  watch: {

  },
  methods: {
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'pay:mch:complaint:query') {
            this.searchShow = true
          }
        })
      }
    },

    async getBusinessListings(){
      this.loading = true;
      const {data: resData} = await this.$get("payment/mch/list?paging=false");
      this.loading = false;
      if (resData.result != 200) return;
      this.BusinessListings = resData.data;
    },
    /**
     * 获取列表
     */
    async queryTableData() {
      this.loading = true;
      const {data: resData} = await this.$get("wxpay/complaint/notify/list", {
        params: {
          ...this.listParams,
          ...this.pages,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      this.tableData = resData.data;
      this.total = resData.page ? resData.page.count : resData.data.length;
    },
    /**
     *  分页长度改变
     */
    handleSizeChange(val) {
      this.pages.pageNo = 1;
      this.pages.pageSize = val;
      this.queryTableData();
    },

    /**
     *  下一页
     */
    handleCurrentChange(val) {
      this.pages.pageNo = val;
      this.queryTableData();
    },
  },
};
</script>
<style lang="scss" scoped="">
.comput_item{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  font-size: 14px;
  width: 300px;
}
.cpmout_box_infos{
  display: flex;
  align-items: center;
}
</style>